export default __webpack_public_path__ + "static/media/project5.8bfa7b7e.PNG";